export default __webpack_public_path__ + "static/media/ic_languages.a76cd6a3.svg";